<template>
  <footer class="footer-container">
    <div class="footer-inner">
      <!-- Sección Superior: Logo y Contenido -->
      <div class="footer-content">
        <img src="@/assets/logo4.png" alt="Logo" class="footer-logo" />
        <div class="footer-text">
          <span class="footer-title">MY EVENTO DIGITAL</span>
      
        </div>
      </div>

      <!-- Sección Inferior: Acción y Copyright -->
      <div class="footer-bottom">
        <span class="footer-prompt">¿Te interesa nuestro servicio?</span>
        <a href="https://wa.link/quzm6l" target="_blank" class="demo-link">Pide un demo</a>
        <span class="copyright">© 2024 My Evento Digital</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&display=swap');

/* ===== FRANJA DISCRETA Y ELEGANTE ===== */
.footer-container {
  width: 100%;
  /* Tono borgoña/moka profundo con línea superior dorada fina */
  background: linear-gradient(180deg, #060606 0%, #0c0a1a 100%);
  border-top: 1px solid #c5a059;
  color: #f7f3ee;
  padding: 24px 15px 18px;
  box-sizing: border-box;
}

.footer-inner {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* ===== LOGO Y MARCA EN UNA SOLA LÍNEA ===== */
.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.footer-logo {
  width: 22px;
  height: auto;
  opacity: 0.85;
  filter: brightness(0) invert(0.85) sepia(0.5) hue-rotate(5deg);
}

.footer-text {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-title {
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 2px;
  color: #dfb76c; /* Dorado fino */
  font-weight: 500;
  text-transform: uppercase;
}

.footer-dot {
  font-size: 8px;
  color: #c5a059;
  opacity: 0.5;
}

.footer-subtext {
  font-family: 'padres', serif;
  font-size: 11px;
  color: #a89a93;
  letter-spacing: 0.5px;
}

/* ===== ACCIÓN Y COPYRIGHT ===== */
.footer-bottom {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 11px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-prompt {
  font-family: 'padres', serif;
  color: #8c7e77;
  font-style: italic;
}

/* Botón Minimalista Fino */
.demo-link {
  font-family: 'Playfair Display', serif;
  color: #dfb76c;
  background: transparent;
  border: 1px solid #c5a059;
  padding: 4px 14px;
  border-radius: 15px;
  text-decoration: none;
  font-size: 8px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.demo-link:hover {
  background-color: #c5a059;
  color: #1a0d0a;
}

.copyright {
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 10px;
  color: #5e524c;
  letter-spacing: 0.5px;
}

@media (max-width: 480px) {
  .footer-container {
    padding: 20px 12px 16px;
  }
  .footer-dot {
    display: none;
  }
  .footer-text {
    flex-direction: column;
    gap: 2px;
  }
  .footer-bottom {
    gap: 8px;
    flex-direction: column;
  }
}
</style>